import IStep from '../../lib/IStep';
import BusinessModel from '../FindYourBusiness/models/BusinessModel';
import SocialMediaModel from './models/SocialMediaModel';

export default class Step implements IStep {
  /**
   * Fired when the step is initialized
   */
  onInit() {
    // run business logic here when the step is initialized
  }

  async onBeforeInit() {
    //const businessData = BusinessModel.getWizardData();
  }
}
